import Vue from 'vue'
import ElementUI from 'element-ui';             //全局引入element
import 'element-ui/lib/theme-chalk/index.css';    //全局引入element的样式
import App from './App.vue'
import router from './router'
import store from './store'
import "amfe-flexible";

import animated from 'animate.css'

import VueAxios from "vue-axios";
import axios from 'axios'
Vue.use(VueAxios, axios)
Vue.use(animated)

import {
  Button,
  Icon,
  Popup,
  Overlay,
  Loading
} from 'vant';


Vue.use(Button);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(ElementUI);     //全局注入element

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')